module.exports = "//static.hsappstatic.net/connect-dot-com-ui/static-1.384/img/logo/connect-full-logo-color.svg"